export const activitiesInitialState = {
	entities: {},
	totalToDisplay: 0,
	skip: 0,
	activitiesToday: 0,
	activitiesThisWeek: 0,
};



// WEBPACK FOOTER //
// ./src/redux/activities/activity.initialState.js